// extracted by mini-css-extract-plugin
module.exports = {"NavBar":"NavBar_NavBar__-XYZQ","Toggle":"NavBar_Toggle__2mn2S","Logo":"NavBar_Logo__doial","AlignRight":"NavBar_AlignRight__2jJw6"};